import { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import Webtoons from '@/components/screens/webtoons/Webtoons';
import { BOOKS_FOR_PAGE, API_URL } from '@/helpers/variables';
import useRedirectToFirstPage from '@/hooks/useRedirectToFirstPage';
import { IGenreBooksPage } from '@/interfaces/genreBooksPage.interface';
import { IWidgetsSideBar } from '@/interfaces/widgets.interface';

interface IWebtoonsPagesDynamicProps extends IWidgetsSideBar {
  books: IGenreBooksPage;
}

const WebtoonsPagesDynamic: NextPage<IWebtoonsPagesDynamicProps> = ({ books, todayWidget, popularBooksWidget }) => {
  return <Webtoons books={books} todayWidget={todayWidget} popularBooksWidget={popularBooksWidget} />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { pageNumber } = context.query;

  const booksRes = await fetch(`${API_URL}genres/aldebaran/books/vebtun?sort_by_popular=true&page=${pageNumber}&page_size=${BOOKS_FOR_PAGE}`);
  const books = await booksRes.json();

  const [todayWidgetRes, popularBooksWidgetRes] = await Promise.all([fetch(`${API_URL}main/today/`), fetch(`${API_URL}main-page/popular_books`)]);
  const [todayWidget, popularBooksWidget] = await Promise.all([todayWidgetRes.json(), popularBooksWidgetRes.json()]);

  return { props: { books, todayWidget, popularBooksWidget } };
};

export default WebtoonsPagesDynamic;
